import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import WhyUseSection from './components/WhyUseSection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import NewsletterSection from './components/NewsletterSection';
import { faqItems } from '@/mocks/categories';
import { SITE_URL as siteUrl } from '@/mocks/siteConfig';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Polska Guide',
  url: siteUrl,
  description: 'Niezależny przewodnik po Kakobuy Spreadsheet dla polskich użytkowników. Znajduj najlepsze produkty, porównuj ceny i korzystaj z wiedzy społeczności.',
  inLanguage: 'pl-PL',
  publisher: {
    '@type': 'Organization',
    name: 'KakobuyPolska',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8caf559f256f.png',
    },
  },
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Kakobuy Polska Guide',
      item: siteUrl,
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatIsSection />
        <WhyUseSection />
        <HowItWorksSection />
        <SafetySection />
        <FAQSection />
        <ArticleCardsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}